exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container[data-v-2e180490]{overflow-y:scroll}\n", ""]);

// exports
